
import React from 'react'
import { Card } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'

import ProgressBar from './ProgressBar'

import './ProjectProgress.scss'

interface Props {
  projectProgress: any
}

const ProjectProgress = ({ projectProgress}: Props) => {

  const { t } = useTranslation()

  const {
    baseline,
    baselineMax,
    scheduled,
    scheduledMax,
    actual,
    projectMax,
  } = projectProgress

  const basePercent = (baseline && baselineMax) ? Math.round((baseline / baselineMax) * 100) : 0
  const scheduledPercent = (scheduled && scheduledMax) ? Math.round((scheduled / scheduledMax) * 100) : 0
  const actualPercent = (actual && projectMax) ? Math.round((actual / projectMax) * 100) : 0

  const deviation = actualPercent - basePercent

  return (
    <Card className='dashboard-progress-card'>
      <Card.Body>
        <h4 className='card-title'>
          {t('PROJECT_DASHBOARD:ProjectProgressTitle')}
        </h4>
        <div className='project-progress'>
          <div className='progress-item'>
            <div className='progress-item-label'>
              {t('PROJECT_DASHBOARD:ProjectProgressBaseLineProgress')}
            </div>
            <div className='progress-item-value'>
              {basePercent}%
            </div>
          </div>
          <ProgressBar value={baseline} max={baselineMax} className='dashboard-progress-bar baseline' />
          <div className='progress-item'>
            <div className='progress-item-label'>
              {t('PROJECT_DASHBOARD:ProjectProgressScheduledProgress')}
            </div>
            <div className='progress-item-value'>
              {scheduledPercent}%
            </div>
          </div>
          <ProgressBar value={scheduled} max={scheduledMax} className='dashboard-progress-bar scheduled' />
          <div className='progress-item'>
            <div className='progress-item-label'>
              {t('PROJECT_DASHBOARD:ProjectProgressActualProgress')}
            </div>
            <div className='progress-item-value'>
              {actualPercent}%
            </div>
          </div>
          <ProgressBar value={actual} max={projectMax} className='dashboard-progress-bar actual' />
        </div>
        <div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default ProjectProgress
